import { Controller } from "@hotwired/stimulus"
import { initTable } from "huntressHelpers"

export default class extends Controller {
  static targets = ["datatable", "loading", "table"]
  static values = { agentId: Number }

  connect() {
    this.tableOptions = {
      language: {
        emptyTable: "No binaries found for this classification"
      },
      columnDefs: [
        { targets: "_all", searchable: false },
        { targets: [3], orderable: false }
      ]
    }
    this.showLastTab()
    $(this.tableTarget).on("init.dt", () => this.tableInitialized())
    initTable(this.currentDataURL, this.tableOptions)
  }

  disconnect() {
    if (this.hasTableTarget) {
      if ($.fn.dataTable.isDataTable(this.tableTarget)) {
        $(this.tableTarget).DataTable().destroy()
      }
      $(this.tableTarget).off("init.dt")
    }
  }

  get storageKey() {
    return `lastBinariesTab_${this.agentIdValue}`
  }

  get currentDataURL() {
    return this.currentTab.dataset.classification
  }

  get currentTab() {
    return this.datatableTarget.querySelector("ul li.active a")
  }

  showLastTab() {
    const lastBinariesTab = localStorage.getItem(this.storageKey)
    if (lastBinariesTab) {
      const tab = this.datatableTarget.querySelector(`a[data-classification="${lastBinariesTab}"]`)
      if (tab) $(tab).tab("show")
    }
  }

  tabChanged(ev) {
    const el = $(ev.currentTarget)
    const table = $(this.tableTarget).DataTable()
    table.state.clear()
    table.destroy()
    initTable(el.data("classification"), this.tableOptions)
    localStorage.setItem(this.storageKey, el.data("classification"))
  }

  tableInitialized() {
    $(this.loadingTarget).hide()
    $(this.datatableTarget).fadeIn()
  }
}
